import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { REQUEST_ERROR, ROUTING_TRAMITE_PENSION, VOUCHER_PENSION } from "@constants/url.constant";
import { GtmService } from "@services/gtm/gtm.service";

@Component({
    selector: "app-tramite-pension-request",
    templateUrl: "./tramite-pension-request.component.html",
    styleUrls: ["./tramite-pension-request.component.scss"],
    standalone: false
})
export class TramitePensionRequestComponent {
  constructor(private readonly activatedRoute: ActivatedRoute, readonly router: Router, private readonly gtmService: GtmService) {}

  goToVoucherPension() {
    this.router.navigate([`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${VOUCHER_PENSION}`], {
      relativeTo: this.activatedRoute,
    });
  }

  goToRequestError() {
    this.router.navigate([`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${REQUEST_ERROR}`], {
      relativeTo: this.activatedRoute,
    });
  }
}
